'use strict';

var PriceRecommendationServicesAnalysisGridDirective = function PriceRecommendationServicesAnalysisGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/price-recommendation-services-analysis-grid.html'),
    replace: true,
    scope: {}
  };
};
PriceRecommendationServicesAnalysisGridDirective.$inject = [];
module.exports = PriceRecommendationServicesAnalysisGridDirective;